import { Component, ViewChild, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { Subject } from "rxjs";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { getApp } from "../app";
import { UserIdleService } from "angular-user-idle";

@Component({
    selector: "app-session-expires-modal",
    templateUrl: "./session-expires-modal.component.html",
    styleUrls: ["./session-expires-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SessionExpiresModalComponent {
  @Input() modalTitle = "";

  @ViewChild("content", { static: true }) content: any;
  @Output() ok = new Subject<any>();

  app = getApp((app) => {
    this.app = app;
  });

  display: string = "";

  constructor(
    private modalService: NgbModal,
    private userIdle: UserIdleService
  ) {}

  ngOnInit() {
    this.timer();
  }

  async open() {
    try {
      const result = await this.modalService.open(this.content, {
        windowClass: "smallModal",
        backdrop: "static",
        keyboard: false,
      }).result;

      this.ok.next(result);
    } catch (err) {
      // NOP
    }
  }

  async timer() {
    let config = this.userIdle.getConfigValue();
    this.userIdle.onTimerStart().subscribe((count) => {
      if (config && config.timeout) {
        const seconds = config.timeout - count;
        const minutes = seconds / 60;
        const prefixMin = minutes < 10 ? "0" : "";
        const prefixSec = seconds % 60 < 10 ? "0" : "";
        this.display = `${prefixMin}${Math.floor(minutes)}:${prefixSec}${
          seconds % 60
        }`;
        if (seconds == 0) {
          this.closeModal();
        }
      }
    });
  }

  async resetTimer() {
    await this.app.auth.checkAuthNoDetails();
    this.display = "";
    this.userIdle.resetTimer();
    this.modalService.dismissAll();
  }

  closeModal() {
    this.userIdle.resetTimer();
    this.modalService.dismissAll();
    this.app.auth.logout();
  }
}
